import { KeyValueDiffers, ViewContainerRef } from '@angular/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { BoardService } from "./board.service";
import { Router } from "@angular/router";
var BoardComponent = (function () {
    function BoardComponent(boardService, differs, toastr, vcr, router) {
        this.boardService = boardService;
        this.differs = differs;
        this.toastr = toastr;
        this.vcr = vcr;
        this.router = router;
        this.toastr.setRootViewContainerRef(vcr);
        this.differ = this.differs.find({}).create();
    }
    BoardComponent.prototype.ngOnInit = function () {
        this.title = "board";
        this.filterParams = {
            size: 10,
            page: 0,
            sortNew: true
        };
    };
    BoardComponent.prototype.ngDoCheck = function () {
        var change = this.differ.diff(this.filterParams);
        if (change) {
            if (this.filterParams.page < 0) {
                this.filterParams.page = 0;
                return;
            }
            else if (this.filterParams.page > this.totalPage - 1) {
                this.filterParams.page = this.totalPage - 1;
                return;
            }
            this.getboardList();
        }
    };
    BoardComponent.prototype.getboardList = function () {
        var _this = this;
        if (this.isLoading) {
            return;
        }
        this.isLoading = true;
        this.boardService.getBoardList(this.filterParams)
            .then(function (res) {
            if (res.status === 1) {
                _this.boardList = res.data.dataList;
                _this.totalElements = res.data.totalElements;
                _this.initPaginate();
                _this.isLoading = false;
            }
            else {
                _this.toastr.error(res.message, 'Error!');
                if (res.errorCode === 3000) {
                    localStorage.setItem("alert", JSON.stringify(res.message));
                    _this.router.navigate(['login']);
                }
            }
        })
            .catch(function (err) { return console.log(err); });
    };
    //init paging 
    BoardComponent.prototype.initPaginate = function () {
        this.totalPage = Math.ceil(this.totalElements / this.filterParams.size);
        var arrPagingNumber = [];
        for (var i = 0; i < this.totalPage; i++) {
            arrPagingNumber.push(i);
        }
        return arrPagingNumber;
    };
    BoardComponent.prototype.showDevice = function (board) {
        this.boardInfo = board;
        $('#myModal').modal('show');
    };
    BoardComponent.prototype.sortLastOnline = function () {
        this.filterParams.sortNew = !this.filterParams.sortNew;
        this.getboardList();
    };
    return BoardComponent;
}());
export { BoardComponent };



// WEBPACK FOOTER //
// /build/client-cms/src/app/board/board.component.ts.pre-build-optimizer.js